/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_CatInputs */

const en_svc_rag_knowledge_assistants_cat = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#KNOW`)
};

const ar_svc_rag_knowledge_assistants_cat = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#معرفة`)
};

const bn_svc_rag_knowledge_assistants_cat = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#KNOW`)
};

const de_svc_rag_knowledge_assistants_cat = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#KNOW`)
};

const es_svc_rag_knowledge_assistants_cat = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#KNOW`)
};

const fr_svc_rag_knowledge_assistants_cat = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#KNOW`)
};

const pt_svc_rag_knowledge_assistants_cat = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#KNOW`)
};

const zh_svc_rag_knowledge_assistants_cat = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#KNOW`)
};

const tr_svc_rag_knowledge_assistants_cat = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#KNOW`)
};

const ru_svc_rag_knowledge_assistants_cat = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#KNOW`)
};

const pl_svc_rag_knowledge_assistants_cat = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#KNOW`)
};

/**
* | output |
* | --- |
* | "#KNOW" |
*
* @param {Svc_Rag_Knowledge_Assistants_CatInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_cat = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_CatInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_CatInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_cat(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_cat(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_cat(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_cat(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_cat(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_cat(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_cat(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_cat(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_cat(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_cat(inputs)
	return en_svc_rag_knowledge_assistants_cat(inputs)
});
export { svc_rag_knowledge_assistants_cat as "svc_rag-knowledge-assistants_cat" }